import { MediaQueryStyleSheet } from 'react-native-responsive';
import { MQ_TABLET, MQ_PHONE, SEPARATOR_STROKE, PALETTE } from "../../../../../../src/constants";

export default MediaQueryStyleSheet.create({
  marketValueLabel: {
    fontSize: 16,
  },


  decimalStyle: {
    fontSize: '1.78vw',
    color: PALETTE.secondaryActive
  },
  marketValueText: {
    color: PALETTE.secondaryActive,
    fontSize: '2.68vw',
  },
  currencyStyle: {
    fontSize: 18,
  },

  columnFlex: {
    flexDirection: "column", display: "flex",
  },
  rowFlex: {
    flexDirection: "row", display: "flex",
  },
  changeIndicatedPercent: {
    marginLeft: 6, 
    fontSize: '1.13vw'
  },
  twrrIndicatedPercent: {
    textAlign: "right", width: '100%', fontSize: '1.13vw', marginTop: '8%'
  },

  dayChangeText: {
    fontSize: 16, 
    color: PALETTE.primaryText
  },
  dayChangeValue: {
    fontSize: '1.13vw',
    color: PALETTE.secondaryActive
  },
  twrrText: {
    textAlign: "right", width: '100%', fontSize: 16, color: PALETTE.primaryText
  }
},
  {
    [MQ_PHONE]: {
      currencyStyle: {
        fontSize: 14,
      },
      align: {
        textAlign: 'center',
      },
      justify: {
        justifyContent: 'center',
      },
    }
  });
